import type { CSSProperties } from 'react'
import type { SelectDropdownPosition } from './types'

/**
 * Converts measured dropdown geometry into the fixed-position style passed to
 * Headless UI listbox options.
 */
export const getSelectListboxStyle = (dropdownPosition: SelectDropdownPosition | null): CSSProperties => ({
  position: 'fixed',
  top: dropdownPosition?.top ?? 0,
  left: dropdownPosition?.left ?? 0,
  width: dropdownPosition?.width,
  maxHeight: dropdownPosition?.maxHeight,
  visibility: dropdownPosition ? 'visible' : 'hidden',
})

